import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20photography%20flatlay%20with%20designer%20sneakers%20leather%20bag%20and%20accessories%20on%20warm%20marble%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20composition%2C%20cream%20and%20beige%20tones%2C%20editorial%20quality%2C%20subtle%20plant%20in%20background%2C%20sophisticated%20aesthetic&width=1600&height=900&seq=hero-main-bg-v2&orientation=landscape&nocache=true"
          alt="Basetao Spreadsheet fashion product resources"
          className="w-full h-full object-cover object-top"
          title="Basetao Spreadsheet ultimate resource hub"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-4xl mx-auto text-center py-20">
        <p className="text-sm md:text-base font-medium text-white/80 mb-4 tracking-widest uppercase">
          The Most Complete Resource Hub
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Basetao Spreadsheet
        </h1>
        <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          The Ultimate Resource Hub For Product Finds, Reviews &amp; Shopping Guides
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Basetao Spreadsheet
            <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <Link
            to="/basetao-spreadsheet-ultimate-guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white/20 backdrop-blur-sm text-white border border-white/30 text-sm md:text-base font-semibold hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
          >
            Read Basetao Reviews
            <i className="ri-article-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Visit Main Website
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}